import "./bootstrap";

// Dynamic import to split non-critical bootstrap bundle
import('bootstrap').then((bootstrap) => {
    window.bootstrap = bootstrap;
});

import './main';
